import { useState, useRef, useEffect } from 'react';
import "./VillageSectionCardDetails.css";
import natureIcon from '../assets/icons/nature.svg'

function PlaceCard({ item, idx, i18n }) {
  const [expanded, setExpanded] = useState(false);
  const [descHeight, setDescHeight] = useState(null);
  const imgRef = useRef(null);
  const descRef = useRef(null);


  // Helper to update descHeight after image loads or expanded state changes
  const updateDescHeight = () => {
    if (imgRef.current && descRef.current) {
      setDescHeight(imgRef.current.offsetHeight);
    }
  };

  useEffect(() => {
    updateDescHeight();
    // Also recalc after a short delay to catch late image/font loads
    const timeout = setTimeout(updateDescHeight, 200);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line
  }, [expanded, item.photo]);

  // Also update descHeight when the image loads (in case it loads after render)
  const handleImgLoad = () => {
    updateDescHeight();
  };

  // Clamp to 300 characters and show read more if needed
  const maxChars = 1000;
  const shouldTruncate = item.description.length > maxChars;
  const displayText = !expanded && shouldTruncate
    ? item.description.slice(0, maxChars) + '...'
    : item.description;

  return (
    <article
      className={`place-row ${idx % 2 === 1 ? 'reverse' : ''}`}
      aria-labelledby={`place-title-${idx}`}
    >
      <div id={`place-title-${idx}`} className="flex items-center gap-2 mb-3">
        <div 
          aria-hidden="true"
          style={{
            width: '24px',
            height: '24px',
            backgroundColor: 'var(--color-primary)',
            WebkitMaskImage: `url(${natureIcon})`,
            WebkitMaskSize: 'contain',
            WebkitMaskRepeat: 'no-repeat',
            WebkitMaskPosition: 'center',
            maskImage: `url(${natureIcon})`,
            maskSize: 'contain',
            maskRepeat: 'no-repeat',
            maskPosition: 'center'
          }}
        />
        <h2 className="m-0 place-title-header">{item.title}</h2>
      </div>
      <div className="place-content-row">
        <div className="place-text">
          <p
            className="place-desc"
            ref={descRef}
            style={expanded ? { maxHeight: 'none', overflow: 'visible' } : descHeight ? { maxHeight: descHeight, overflow: 'hidden' } : {}}
          >
            {displayText}
            {shouldTruncate && !expanded && (
              <span className="read-more" style={{ color: 'var(--color-primary)', cursor: 'pointer', marginLeft: 8 }} onClick={() => setExpanded(true)}>
                {i18n.language === 'mr' ? 'अधिक वाचा' : 'Read more'}
              </span>
            )}
            {shouldTruncate && expanded && (
              <span className="read-more" style={{ color: 'var(--color-primary)', cursor: 'pointer', marginLeft: 8 }} onClick={() => setExpanded(false)}>
                {i18n.language === 'mr' ? 'कमी दाखवा' : 'Show less'}
              </span>
            )}
          </p>
        </div>
        <div className={`place-image-wrap ${idx % 2 === 1 ? 'image-start' : 'image-end'}`}>
          <img loading="lazy" ref={imgRef} className="place-image" src={item.photo} alt={item.title} onLoad={handleImgLoad} />
        </div>
      </div>
    </article>
  );
}

export default PlaceCard;